/* ALB Logo-Slider (sections/alb-logo-slider.liquid) – nur im mobilen Wisch-Modus geladen.
   Die Logo-SVGs haben alle dieselbe Zeichenfläche, das eigentliche Logo sitzt darin mit sehr
   unterschiedlich viel Leerraum (DVGW füllt z. B. nur 40 % der Breite). Damit die sichtbaren
   Abstände gleich sind, wird der Umriss (getBBox) je SVG gemessen und nur dieser Ausschnitt
   gezeigt: Seitenverhältnis + Masken-Größe/-Position als CSS-Variablen am Logo (2026-09-30). */
(function () {
  if (window.albLsTrimInit) return; window.albLsTrimInit = true;
  var cache = {};
  function measure(url) {
    if (!cache[url]) {
      cache[url] = fetch(url).then(function (r) { return r.text(); }).then(function (txt) {
        var box = document.createElement('div');
        box.style.cssText = 'position:absolute;left:-9999px;top:0;width:400px;visibility:hidden';
        box.innerHTML = txt;
        document.body.appendChild(box);
        var svg = box.querySelector('svg');
        var res = null;
        if (svg && svg.viewBox && svg.viewBox.baseVal && svg.viewBox.baseVal.width) {
          var vb = svg.viewBox.baseVal, bb = svg.getBBox();
          if (bb.width > 0 && bb.height > 0) res = { vb: vb, bb: bb };
        }
        box.remove();
        return res;
      }).catch(function () { return null; });
    }
    return cache[url];
  }
  function trim(span) {
    var m = getComputedStyle(span).getPropertyValue('--alb-logo-mask').trim();
    var url = m.replace(/^url\((['"]?)/, '').replace(/(['"]?)\)$/, '');
    if (!url || url.indexOf('.svg') === -1) return;
    measure(url).then(function (r) {
      if (!r) return;
      var vb = r.vb, bb = r.bb, slide = span.closest('.alb-logo-slide');
      if (!slide) return;
      var pad = 0.02; /* 2 % Luft, damit Kanten nicht angeschnitten wirken */
      var bx = Math.max(vb.x, bb.x - vb.width * pad), by = Math.max(vb.y, bb.y - vb.height * pad);
      var bw = Math.min(vb.x + vb.width, bb.x + bb.width + vb.width * pad) - bx;
      var bh = Math.min(vb.y + vb.height, bb.y + bb.height + vb.height * pad) - by;
      var sx = vb.width / bw * 100, sy = vb.height / bh * 100;
      var px = vb.width - bw > 0 ? (bx - vb.x) / (vb.width - bw) * 100 : 50;
      var py = vb.height - bh > 0 ? (by - vb.y) / (vb.height - bh) * 100 : 50;
      slide.style.setProperty('--alb-logo-ar-trim', (bw / bh).toFixed(3));
      slide.style.setProperty('--alb-logo-msize', sx.toFixed(2) + '% ' + sy.toFixed(2) + '%');
      slide.style.setProperty('--alb-logo-mpos', px.toFixed(2) + '% ' + py.toFixed(2) + '%');
      slide.classList.add('is-trimmed');
      size(slide, bw / bh);
    });
  }
  /* Optisch gleiche Größe: gleiche Fläche statt gleicher Höhe (Fläche 1,8·h², h = „Logo-Höhe Mobile“);
     kompakte Logos dürfen bis ca. 1,34·h hoch werden (30 -> 40 px), breite max. „Logo-Breite Mobile“. */
  function size(slide, ar) {
    var sec = slide.closest('[data-logo-h-m]'); if (!sec || !(ar > 0)) return;
    var h0 = parseFloat(sec.getAttribute('data-logo-h-m')) || 30, wMax = parseFloat(sec.getAttribute('data-logo-w-m')) || 110;
    var hMax = h0 * 1.34, area = 1.8 * h0 * h0;
    var w = Math.sqrt(area * ar), h = w / ar;
    if (h > hMax) { h = hMax; w = h * ar; }
    if (w > wMax) { w = wMax; h = w / ar; }
    slide.style.setProperty('--alb-logo-mw', w.toFixed(1) + 'px');
    slide.style.setProperty('--alb-logo-mh', h.toFixed(1) + 'px');
    slide.classList.add('is-sized');
    fitLater(slide.closest('.alb-logo-slider'));
  }
  /* Passen alle Logos in die Breite: zentriert und ohne Wischen (Klasse is-fit), sonst Slider am
     linken Rand. Bei jeder Größenänderung neu prüfen. */
  function fit(sec) {
    if (!sec) return;
    var tr = sec.querySelector('.alb-ls-track'); if (!tr) return;
    var slides = Array.prototype.filter.call(tr.querySelectorAll('.alb-logo-slide'), function (el) { return el.offsetParent !== null; });
    if (!slides.length) return;
    sec.classList.remove('is-fit');
    /* Breite der Logos inkl. Abstände gegen die verfügbare Breite (Spur minus Innenabstand links/rechts) */
    var cs = getComputedStyle(tr);
    var avail = tr.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    /* Passt es mit mind. 16px Abstand: zentriert, Abstand wächst mit dem freien Platz bis max. 32px */
    var sumW = 0; slides.forEach(function (el) { sumW += el.getBoundingClientRect().width; });
    var n = slides.length, minGap = 16, maxGap = 32;
    var fits = sumW + (n - 1) * minGap <= avail + 1;
    if (fits) {
      var g = n > 1 ? Math.min(maxGap, Math.max(minGap, (avail - sumW) / (n - 1))) : 0;
      sec.style.setProperty('--alb-ls-fitgap', Math.floor(g) + 'px');
    }
    sec.classList.toggle('is-fit', fits);
  }
  var fitT = {};
  function fitLater(sec) {
    if (!sec) return;
    var id = sec.id || 'x';
    clearTimeout(fitT[id]);
    fitT[id] = setTimeout(function () { fit(sec); }, 30);
  }
  function run() {
    document.querySelectorAll('.alb-logo-slider.alb-ls--scroll .alb-logo-img--tint').forEach(trim);
    document.querySelectorAll('.alb-logo-slider.alb-ls--scroll').forEach(fitLater);
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('.alb-logo-slider.alb-ls--scroll').forEach(fitLater);
  }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
